<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-book"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
  <div class="header-actions">
    <button pButton [label]="botoes.voltar" icon="pi pi-arrow-left"
      class="p-button-text"
      [pTooltip]="tooltips.voltar" tooltipPosition="top"
      (click)="voltarParaLista()"></button>
  </div>
</div>

<div class="cards-container">
  <!-- Card: Extrato de Estoque -->
  <div class="table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-book"></i>
      </div>
      <div class="card-header-info">
        <span class="card-header-title">{{ texts.titulo }}</span>
        <span *ngIf="itemNome" class="card-header-subtitle">
          {{ labels.item }}: {{ itemNome }} (Cod: {{ itemCodigo }})
        </span>
      </div>
    </div>
    <div class="card-content">

      <!-- Barra de busca + Seletor de colunas -->
      <div class="search-bar">
        <p-iconField iconPosition="right" class="search-field">
          <p-inputIcon styleClass="pi pi-search" />
          <input pInputText type="text"
            [placeholder]="placeholders.pesquisar"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange($event)" />
        </p-iconField>

        <app-column-selector
          [columns]="columns"
          [storageKey]="STORAGE_KEY"
          (columnsChange)="onColumnsChange($event)">
        </app-column-selector>
      </div>

      <!-- Tabela -->
      <p-table [value]="extratos" [loading]="loading"
        (sortFunction)="customSort($event)" [customSort]="true"
        [tableStyle]="{ 'width': '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th [hidden]="!isColumnVisible('codigoEstoque')" pSortableColumn="codigoEstoque" style="width: 10%">
              {{ labels.codigo_estoque }}<p-sortIcon [field]="'codigoEstoque'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('tipoOperacao')" style="width: 13%">
              {{ labels.tipo_operacao }}
            </th>
            <th [hidden]="!isColumnVisible('quantidade')" pSortableColumn="quantidade" style="width: 10%">
              {{ labels.quantidade }}<p-sortIcon [field]="'quantidade'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('saldoAnterior')" pSortableColumn="saldoAnterior" style="width: 12%">
              {{ labels.saldo_anterior }}<p-sortIcon [field]="'saldoAnterior'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('saldo')" pSortableColumn="saldo" style="width: 12%">
              {{ labels.saldo_final }}<p-sortIcon [field]="'saldo'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('origem')" style="width: 15%">
              {{ labels.origem }}
            </th>
            <th [hidden]="!isColumnVisible('emissao')" pSortableColumn="emissao" style="width: 18%">
              {{ labels.data_emissao }}<p-sortIcon [field]="'emissao'"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-extrato>
          <tr class="linha-clicavel" (click)="navegarParaDetalhe(extrato)"
            [pTooltip]="extrato.ajusteDeEstoque ? tooltips.ver_ajuste : extrato.nota ? tooltips.ver_nota : ''"
            tooltipPosition="top">
            <td [hidden]="!isColumnVisible('codigoEstoque')">{{ extrato.codigoEstoque }}</td>
            <td [hidden]="!isColumnVisible('tipoOperacao')">
              <span *ngIf="extrato.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.ENTRADA || extrato.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.ENTRADA"
                class="badge-tipo badge-entrada">
                <i class="pi pi-arrow-up"></i>
                {{ labels.entrada }}
              </span>
              <span *ngIf="extrato.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.SAIDA || extrato.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.SAIDA"
                class="badge-tipo badge-saida">
                <i class="pi pi-arrow-down"></i>
                {{ labels.saida }}
              </span>
            </td>
            <td [hidden]="!isColumnVisible('quantidade')">
              <span class="saldo-com-icone">
                {{ extrato.quantidade }}
                <i *ngIf="extrato.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.ENTRADA || extrato.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.ENTRADA"
                  class="pi pi-arrow-up saldo-icone-entrada"></i>
                <i *ngIf="extrato.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.SAIDA || extrato.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.SAIDA"
                  class="pi pi-arrow-down saldo-icone-saida"></i>
              </span>
            </td>
            <td [hidden]="!isColumnVisible('saldoAnterior')">{{ extrato.saldoAnterior }}</td>
            <td [hidden]="!isColumnVisible('saldo')">
              <span class="saldo-com-icone">
                {{ extrato.saldo }}
                <i *ngIf="extrato.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.ENTRADA || extrato.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.ENTRADA"
                  class="pi pi-arrow-up saldo-icone-entrada"></i>
                <i *ngIf="extrato.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.SAIDA || extrato.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.SAIDA"
                  class="pi pi-arrow-down saldo-icone-saida"></i>
              </span>
            </td>
            <td [hidden]="!isColumnVisible('origem')">{{ getOrigem(extrato) }}</td>
            <td [hidden]="!isColumnVisible('emissao')">{{ extrato.emissao | date:'dd/MM/yyyy HH:mm' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ texts.nenhuma_movimentacao }}</div>
                <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ texts.carregando }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Paginacao -->
      <div class="pagination-container">
        <div>
          <p-paginator (onPageChange)="onPageChange($any($event))"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>
